var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-date-range-manual",class:{ center: _vm.center }},[_c('div',{staticClass:"date-ranges"},[_c('div',{staticClass:"date-item"},[_c('date-input',{attrs:{"typeable":true,"icon":"calendar_new","manual":"","disabled-dates":_vm.disabledDates},on:{"input":_vm.onInput},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})],1)]),_vm._v(" "),(
            !_vm.hideRangeText &&
                _vm.newValue &&
                _vm.dateLengthText.toString() !== 'משך הביטוח: NaN ימים'
        )?_c('div',{staticClass:"insurance-date-text",domProps:{"innerHTML":_vm._s(_vm.dateLengthText)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }